"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidConfiguration = exports.getValue = exports.findAddressComponent = exports.retrieveAddressByCoords = exports.checkAddressIsValid = exports.geolocation = void 0;

var _constants = require("./constants");

var geolocation = function geolocation(message) {
  return navigator.geolocation ? navigator.geolocation : {
    getCurrentPosition: function getCurrentPosition(success, failure) {
      failure(message);
    }
  };
};

exports.geolocation = geolocation;

var checkAddressIsValid = function checkAddressIsValid(latLng, usePolygon, polygon) {
  // Check if a position is included on Utility polygon or if utility hasn't setted a polygon
  // To set map in this position
  var utilityPolygon = new window.google.maps.Polygon({
    paths: polygon
  });
  return !usePolygon || window.google.maps.geometry.poly.containsLocation(latLng, utilityPolygon);
};

exports.checkAddressIsValid = checkAddressIsValid;

var retrieveAddressByCoords = function retrieveAddressByCoords(_ref, onAddressFoundCallback) {
  var location = _ref.location,
      address = _ref.address;
  var geocoder = new window.google.maps.Geocoder();
  var parameters = address ? {
    address: address
  } : {
    location: location
  };
  geocoder.geocode(parameters, function (results, status) {
    if (status === 'OK') {
      var addressResults = results.filter(function (result) {
        return result.types.some(function (type) {
          return type === _constants.ADDRESS_TYPES.street || type === _constants.ADDRESS_TYPES.route;
        });
      });
      var addressByRange = addressResults.find(function (elem) {
        return elem.geometry.location_type === _constants.LOCATION_TYPES.rooftop;
      }) || addressResults.find(function (elem) {
        return elem.geometry.location_type === _constants.LOCATION_TYPES.rangeInterpolated;
      }) || addressResults.find(function (elem) {
        return elem.geometry.location_type === _constants.LOCATION_TYPES.geometricCenter;
      });
      if (addressByRange) onAddressFoundCallback(addressByRange);
    }
  });
};

exports.retrieveAddressByCoords = retrieveAddressByCoords;

var findAddressComponent = function findAddressComponent(address, component) {
  var addrComponent = address.address_components.find(function (attribute) {
    return attribute.types.includes(component);
  });
  return addrComponent && addrComponent.long_name;
};

exports.findAddressComponent = findAddressComponent;

var getValue = function getValue(address, latLng, paramName) {
  switch (paramName) {
    case _constants.GMAP_PARAMS.latitude:
      return latLng.lat();

    case _constants.GMAP_PARAMS.longitude:
      return latLng.lng();

    case _constants.GMAP_PARAMS.formattedAddress:
      return address.formatted_address;

    default:
      return findAddressComponent(address, paramName);
  }
}; // configuration.address_components


exports.getValue = getValue;

var isValidConfiguration = function isValidConfiguration(field) {
  return field && field.configuration && field.configuration.address_components && field.configuration.address_components[_constants.GMAP_PARAMS.latitude] && field.configuration.address_components[_constants.GMAP_PARAMS.longitude] && field.configuration.address_components[_constants.GMAP_PARAMS.formattedAddress];
};

exports.isValidConfiguration = isValidConfiguration;